$(document).ready(function () {
	(behaviour.indexOf('workDetails') >=0 )?showhideEPForms():null;
});

var showhideEPForms = function () {
     $("tr.enable-toggle").click(function(){
            var child = $(this).next().children();
            $(".outerwrapper").hide();
			if($(this).attr("class") == "enable-toggle"){
            	$("tr.enable-toggle").removeClass('open');
			}
            if($(this).attr("class") == "enable-toggle open"){
                    child.children().hide();
                    $(this).removeClass('open');
            }else{
                    $(this).toggleClass('open');
                    child.children().slideToggle("slow");
            }
    });
}